"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var Portal = function (_a) {
    var children = _a.children, portalNode = _a.portalNode;
    var _b = (0, react_1.useState)(false), mounted = _b[0], setMounted = _b[1];
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    return mounted
        ? //@ts-ignore
            (0, react_dom_1.createPortal)(children, document.querySelector("#".concat(portalNode)))
        : null;
};
exports.default = Portal;
